<template>
  <div class="app">
    <AppHeader fixed>
      <!-- <SidebarToggler class="d-lg-none" display="md" mobile /> -->
      <b-link class="navbar-brand" :href="prefix" >
        <h5 style="margin-left: 60px">ULTRA ONE DAY – CMS</h5>
        <!-- <img class="navbar-brand-full" src="static/img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="static/img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo"> -->
      </b-link>
      <!-- <SidebarToggler class="d-md-down-none" display="lg" /> -->
      <!-- <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3">Dashboard</b-nav-item>
        <b-nav-item class="px-3">Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav> -->
      <b-navbar-nav class="ml-auto">
        <!-- <HeaderDropdown right no-caret>
          <template slot="header">
            <i class="fas fa-retweet"></i>
            <b-badge pill variant="danger" v-if="totalNotiCount > 0">{{totalNotiCount}}</b-badge>
          </template>
          <template slot="dropdown">
            <b-dropdown-header tag="div" class="text-center"><strong>{{$t('osm.contents.general.renewal')}}</strong></b-dropdown-header>
            <b-dropdown-item><i class="fas fa-code-branch" /> {{$t('osm.contents.general.gi')}}
              <b-badge variant="danger">{{ giRenewalItemCount }}</b-badge>
            </b-dropdown-item>
            <b-dropdown-item><i class="fas fa-heart" /> {{$t('osm.contents.general.life')}}
              <b-badge variant="danger">{{ lifeRenewalItemCount }}</b-badge>
            </b-dropdown-item>
          </template>
        </HeaderDropdown> -->
<!--         <b-nav-item class="d-md-down-none mx-2" v-if="permissionLevel<7">
          <NotificationBubble></NotificationBubble>
        </b-nav-item> -->
        <!--   <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
 -->
<!--         <b-nav-item class="d-md-down-none">
          <LocaleSwitcher class="mr-3" :locales="['en_us','zh_hk', 'zh_cn']" :show-full="true" />
        </b-nav-item> -->
        <b-nav-item class="d-md-down-none">
          <b-button variant="link" size="md" @click="logout">{{ $t('general.logout') }}</b-button>
        </b-nav-item>
        <!-- <DefaultHeaderDropdownAccnt/> -->
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view style="height: 100%; overflow: hidden;"></router-view>
        </div>
      </main>
    </div>
    <Footer>
    </Footer>
  </div>
</template>
<script>
import nav from '../_nav'
import { Header as AppHeader, HeaderDropdown, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Breadcrumb, LocaleSwitcher, Footer, NotificationBubble } from '@/components'
import DafaultAside from './DafaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import Cookies from 'js-cookie'

export default {
  name: 'MyContainer',
  components: {
    LocaleSwitcher,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    Footer,
    Breadcrumb,
    DafaultAside,
    DefaultHeaderDropdownAccnt,
    HeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NotificationBubble
  },
  data() {
    return {
    giRenewalItemCount: 0,
      lifeRenewalItemCount: 0
    }
  },

  created() {
    // Cookies.set('role', 'admin');
  },
  methods: {
    logout() {
      this.removeAllCookies();
      // location.reload();
      this.$router.replace('/');
    },
    removeAllCookies() {
      Cookies.remove('role');
      Cookies.remove('permissionLevel');
      Cookies.remove('token');
      // document.cookie.split(";").forEach(function(c) {
      //   document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      // });
    }
  },
  computed: {
    prefix() {
      return process.env.PREFIX_PATH
    },
    totalNotiCount() {
      return parseInt(this.giRenewalItemCount) + parseInt(this.lifeRenewalItemCount)
    },
    permissionLevel() {
      return this.$store.state.permissionLevel
    },
    navItems() {
      // let role = Cookies.get('role');
      // if (!role) {
      //   this.logout();
      // }
      // let items = [];
      // let permissionLevel = -1;
      // switch (role) {
      //   case "client":
      //     items = nav.Client;
      //     permissionLevel = 7;
      //     break;
      //   case "assistant":

      //     items = nav.Agent;
      //     permissionLevel = 6;
      //     break;
      //   case "agent":
      //     items = nav.Agent;
      //     permissionLevel = 5;
      //     break;
      //   case "manager":

      //     items = nav.Agent;
      //     permissionLevel = 4;
      //     break;
      //   case "admin":
      //     items = nav.Admin;
      //     permissionLevel = 3;
      //     break;
      //   case "ce":

      //     items = nav.Admin;
      //     permissionLevel = 2;
      //     break;
      //   case "super admin":
      //     items = nav.Admin;
      //     permissionLevel = 1;
      //     break;
      //   case "root":
      //     items = nav.Root;
      //     permissionLevel = 0;
      //     break;
      //   default:
      //     items = [];
      //     permissionLevel = -1;
      //     this.logout();
      //     break;
      // }
      // Cookies.set('permissionLevel', permissionLevel);
      // this.$store.commit('setRole', { role: role, level: permissionLevel });
      if(Cookies.get('role') == 'A')
      return nav.admin;
      else
      return nav.Sample;
    },
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched
    }
  }
}

</script>
<style type="text/css">
/*  .navbar-brand{
    margin-left: 100px;
  }*/
</style>


// WEBPACK FOOTER //
// src/containers/MyContainer.vue